<template>
	<div class="container" style="margin-top: 70px;" v-if="artista">
        <div class="row">
            <div class="col s12 l5">

                <div class="card">
                    <div class="card-image">
                    <img :src="artista.images[0].url">
                        <div class="card-title" style="background-color: rgb(0,0,0,.5) !important;"><i class="material-icons">person</i> {{ artista.name }}</div>
                    </div>
                    <div class="card-content">
                        <p><b>Seguidores</b>: {{ artista.followers.total }}</p>
                        <ul class="collection">
                            <li class="collection-item" v-for="genero in artista.genres" :key="genero">
                                {{genero}}
                            </li>
                        </ul>
                    </div>
                    <div class="card-action">
                        <a :href="artista.external_urls.spotify" target="_blank">Ver en Spotify <i class="material-icons">open_in_new</i></a>
                    </div>
                </div>

            </div>

            <div class="col s12 l7">
                <div class="card">
                    <ul class="collapsible">
                        <li v-if="albums">
                            <div class="collapsible-header"><i class="material-icons">album</i>Álbumes</div>
                            <div class="collapsible-body">
                                <ul class="collection">
                                    <li class="collection-item avatar" v-for="(album, index) in albums.items" :key="index">
                                        <img :src="album.images[1].url" alt="album_image" class="circle">
                                        <span class="title">{{ album.name }}</span> <br>
                                        <small>{{ album.release_date }}</small>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        <li v-if="relateds">
                            <div class="collapsible-header"><i class="material-icons">people</i>Salmistas relacionados</div>
                            <div class="collapsible-body">
                                <ul class="collection">
                                    <li class="collection-item avatar" v-for="(artist, index) in relateds" :key="index">
                                        <img :src="artist.images[1].url" alt="album_image" class="circle">
                                        <span class="title">{{ artist.name }}</span> <br>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        <li v-if="topTracks">
                            <div class="collapsible-header"><i class="material-icons">queue_music</i>Alabanzas más escuchadas</div>
                            <div class="collapsible-body">
                                <ul class="collection">
                                    <li class="collection-item avatar" v-for="(track, index) in topTracks" :key="index">
                                        <img :src="track.album.images[1].url" alt="album_image" class="circle">
                                        <span class="title">{{ track.name }}</span> <br>
                                        <small>{{ track.album.name }}</small>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

        </div>
	</div>
</template>
<script>
import M from 'materialize-css'
import {getToken, getArtist, getArtistTopTracks, getArtistAlbum, getArtistRelated} from "@/spotify";

export default{
	name: 'Salmista',

    data() {
        return {
            artista: {},
            topTracks: {},
            albums: {},
            relateds: {}
        }
    },

	async created(){
        const token = await getToken()
        const id = this.$route.params.id

        this.artista = await getArtist(token, id)
        this.topTracks = await getArtistTopTracks(token, id)
        this.albums = await getArtistAlbum(token, id)
        this.relateds = await getArtistRelated(token, id)

        M.AutoInit()
        window.$('.collapsible').collapsible()
	},
}
</script>
<style scoped>
.card-title {
    min-width: 0 !important;
    width: 100% !important;
}
.collapsible-body {
    padding: 0;
}
</style>